<template>
    <b-card-group
        v-bind="$props"
    >
        <slot />
    </b-card-group>
</template>

<script>
import { BCardGroup } from 'bootstrap-vue'

export default {
    components: { BCardGroup },
    props: {
        columns: { type: Boolean, default: false },
        deck: { type: Boolean, default: false },
        tag: { type: String, default: 'div' },
    }
}
</script>